// Admin copy of the web app's src/device/DeviceHome.jsx for Oireachtas job
// devices (card 540f21a4): same page, the admin's Oireachtas screens. Keep in step.
// The home screen of an event-day job device (card 540f21a4): which event and
// job this device is for, and the screens that job includes. Leaving device
// mode (after a confirm) forgets the device here; the organizer can also
// revoke it from the Job devices screen.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../Organizer/OireachtasPanel/oireachtas.css';
import '../Organizer/OireachtasPanel/organizerOireachtas.css';
import './deviceHome.css';
import { Msr, useMaterialSymbols } from '../Organizer/OireachtasPanel/symbols';
import { useJobDevice } from './DeviceContext';
import { forgetDevice } from './deviceSession';
import { OX_SCREENS, screenLink } from './deviceScreens';

export default function DeviceHome() {
  useMaterialSymbols();
  const { device, me, can } = useJobDevice();
  const [confirmLeave, setConfirmLeave] = useState(false);
  if (!device) return null;
  const event = { _id: device.eventId, name: me?.event?.name || device.eventName };
  const screens = me ? OX_SCREENS.filter((s) => can(...s.any)) : [];

  const leave = () => {
    forgetDevice();
    window.location.replace(`${process.env.REACT_APP_USER_BASE}/device`);
  };

  return (
    <div className="oir dh-page">
      <div className="wrap">
        <header className="dh-head">
          <div>
            <div className="dh-event">{event.name || 'Event'}</div>
            <div className="dh-job">
              <Msr>badge</Msr> {device.roleName}
              {device.label ? <span className="dh-label"> · {device.label}</span> : null}
            </div>
          </div>
          {confirmLeave ? (
            <div className="dh-leave">
              <span>Stop using this device for the event?</span>
              <button type="button" className="op-btn sm danger" onClick={leave}>
                Stop
              </button>
              <button type="button" className="op-btn sm" onClick={() => setConfirmLeave(false)}>
                Keep
              </button>
            </div>
          ) : (
            <button type="button" className="op-btn sm" onClick={() => setConfirmLeave(true)}>
              <Msr>logout</Msr> Leave device mode
            </button>
          )}
        </header>

        {!me ? (
          <p className="dh-wait">Loading this device's job…</p>
        ) : screens.length ? (
          <div className="dh-grid">
            {screens.map((s) => (
              <Link key={s.key} className="dh-card" to={screenLink(s, event)}>
                <Msr>{s.icon}</Msr>
                <span className="dh-title">{s.title}</span>
                <span className="dh-desc">{s.description}</span>
              </Link>
            ))}
          </div>
        ) : (
          <p className="dh-wait">This device's job has no screens yet. Ask the organizer.</p>
        )}
      </div>
    </div>
  );
}
